<template>
    <v-dialog lazy  fullscreen v-model="dialog" transition="dialog-bottom-transition" >
        <v-toolbar dark color="primary" fixed>
            <v-btn icon dark @click="hide">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Editar Datos de Pago</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn :loading="loading" :disabled="!validPayment" color="transparent" depressed @click="savePayment">Guardar</v-btn>
        </v-toolbar>
        <v-card class="mt-4 pt-4">
            <v-card-text>
                <v-container mt-4>
                    <v-layout wrap align-center justify-center>
                        <v-flex xs12 md8 lg6  pt-4 mt-4>
                            <v-layout wrap>
                                <template v-if="appointment">
                                    <v-slide-y-transition>
                                        <v-flex xs12  text-xs-center>
                                            <attention-payment-form
                                                    ref="paymentForm"
                                                    :value="appointment.payment"
                                                    v-on:update:valid="validPayment = $event"
                                            />
                                        </v-flex>
                                    </v-slide-y-transition>
                                </template>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

    import AttentionPaymentForm from '@/components/payment/AttentionPaymentForm'

    import {ApiUtils} from '@/utils/ApiUtils'
    import {getLabel} from '@/utils/Institution'

    import {mapState, mapMutations, mapGetters} from 'vuex'

    export default{
        components: {
            AttentionPaymentForm
        },
        props: [],
        data(){
            return {
                dialog: false,
                other: false,
                reason: null,
                appointment: null,
                loading: false,
                validPayment: false,
            }
        },
        methods: {
            ...mapMutations(['showSnackBar']),
            getLabel,
            show(appointment){
                this.appointment = appointment
                this.dialog = true
            },
            hide(){
                this.dialog = false
            },
            async savePayment(){

                var vm = this
                if(vm.loading) return

                vm.loading = true
                const response = await ApiUtils.makePost(
                        `payment/${vm.appointment.id}`,
                        vm.$refs.paymentForm.getPaymentData()
                )
                vm.loading = false

                if(response.ok){
                    const json = await response.json()
                    vm.$emit('success', json.result.payment)
                    vm.showSnackBar(`Datos de pago actualizados correctamente`)
                }

            }
        },
        computed: {
          ...mapState(['currentProvider', 'currentUser']),
          ...mapGetters(['specialistSettings']),
            suggestedPrice(){

            }
        },
        watch:{}

    }
</script>